import React from 'react';

export default class TableDataEditor extends React.PureComponent {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.input = React.createRef();
    }

    componentDidMount() {
        this.input.current.focus();
    }

    handleChange(e) {
        this.props.onChange(e.target.value);
    }

    render() {
        const { value, onKeyDown } = this.props;

        return (
            <>
                <p>{value}</p>
                <textarea
                    ref={this.input}
                    className="data-editor"
                    value={value}
                    onChange={this.handleChange}
                    onKeyDown={onKeyDown}
                />
            </>
        );
    }
}
